(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-engineering"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('solenne-engineering')){
    customElements.define('solenne-engineering',class extends HTMLElement{
      connectedCallback(){
        this.motion=this.dataset.motion==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches;
        if(!this.motion)return;
        this.classList.add('motion-ready');
        this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.classList.add('is-visible');this.observer.disconnect()}},{threshold:.14});
        this.observer.observe(this);
        this.visual=this.querySelector('[data-visual]');
        this.onScroll=()=>{if(this.frame||!this.visual)return;this.frame=requestAnimationFrame(()=>{const rect=this.visual.getBoundingClientRect();const progress=Math.max(-1,Math.min(1,(innerHeight/2-(rect.top+rect.height/2))/innerHeight));this.visual.style.setProperty('--image-shift',(-4+progress*3)+'%');this.frame=null})};
        addEventListener('scroll',this.onScroll,{passive:true});this.onScroll();
      }
      disconnectedCallback(){if(this.observer)this.observer.disconnect();if(this.onScroll)removeEventListener('scroll',this.onScroll);if(this.frame)cancelAnimationFrame(this.frame)}
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pillars"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('solenne-promise')){
    customElements.define('solenne-promise',class extends HTMLElement{
      connectedCallback(){
        if(this.dataset.motion!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
        this.classList.add('motion-ready');
        this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.classList.add('is-visible');this.observer.disconnect()}},{threshold:.12});
        this.observer.observe(this)
      }
      disconnectedCallback(){if(this.observer)this.observer.disconnect()}
    })
  }

  } catch(e) { console.error(e); }
})();
})();
